import Vue from "vue";
import Router from "vue-router";
import error404 from "@/components/404/error";
import store from "@/store/index";

// 进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch((err) => err);
};

// 处理路由的Name
function routerFuleter(arr, path) {
  // if(path.substr(0,8)=='/bkasset')
  let a;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].path == path) {
      a = arr[i];
      break;
    }
    if (arr[i].children) {
      routerFuleter(arr[i].children, path);
    }
  }
  if (a) {
    let t = a.path.substr(1).split("/");

    if (t[0] == "asset") {
      t = "资产管理";
    } else if (t[0] == "pd") {
      t = "盘点任务";
    } else if (t[0] == "finance") {
      t = "财务管理";
    } else if (t[0] == "sys") {
      t = "系统设置";
    } else if (t[0] == "ent") {
      t = "平台管理";
    } else if (t[0] == "home") {
      t = "";
    }
    if (t) {
      a.titleArr = [t, a.title];
    } else {
      a.titleArr = [a.title];
    }
  }
  return a;
}

const router = new Router({
  // mode: 'hash', //去掉#号
  base: "/bkasset",
  routes: [
    {
      path: "/home",
      name: "/",

      // redirect: '/home',
      component: () => import("../components/layout/index.vue"),
      children: [
        {
          path: "/home",
          name: "home",
          title: "首页",
          component: () => import("@/views/home/index"),
        },
        {
          path: "/home/deptCountMore",
          name: "home_deptCountMore",
          title: "首页-更多",
          component: () => import("@/views/home/deptCountMore"),
        },
        {
          path: "/finance/page",
          name: "",
          title: "资产信息",
          component: () => import("@/views/finance/page/index"),
        },
        /* sys 系统设置 start */
        {
          path: "/sys/classify",
          name: "sys_classify",
          title: "资产分类",
          component: () => import("@/views/sys/classify/index"),
        },
        {
          path: "/sys/dept",
          name: "sys_dept",
          title: "组织架构",
          component: () => import("@/views/sys/dept/index"),
        },
        {
          path: "/sys/alarm",
          name: "sys_alarm",
          title: "出入记录",
          component: () => import("@/views/sys/alarm/index"),
        },
        {
          path: "/sys/permission",
          name: "sys_permission",
          title: "权限设置",
          component: () => import("@/views/sys/permission/index"),
        },
        {
          path: "/sys/area",
          name: "sys_area",
          title: "区域管理",
          component: () => import("@/views/sys/area/index"),
        },
        {
          path: "/sys/dictionaries",
          name: "sys_dictionaries",
          title: "字典配置",
          component: () => import("@/views/sys/dictionaries/index"),
        },
        {
          path: "/sys/login",
          name: "sys_login",
          title: "登录日志",
          component: () => import("@/views/sys/login/index"),
        },
        {
          path: "/sys/operation",
          name: "sys_operation",
          title: "操作日志",
          component: () => import("@/views/sys/operation/index"),
        },
        {
          path: "/sys/template",
          name: "sys_template",
          title: "资产模板",
          component: () => import("@/views/sys/template/index"),
        },
        {
          path: "/sys/print",
          name: "sys_print",
          title: "打印模板",
          component: () => import("@/views/sys/print/index"),
        },
        {
          path: "/sys/examine",
          name: "sys_examine",
          title: "审批设置",
          component: () => import("@/views/sys/examine/index"),
        },

        /* sys 系统设置 end */

        /* 资产管理 start */
        {
          path: "/asset/add",
          name: "",
          title: "资产录入",
          component: () => import("@/views/asset/add/index"),
        },
        {
          path: "",
          name: "asset_add_bind",
          title: "资产录入-绑定EPC",
          component: () => import("@/views/asset/add/epc_bind"),
        },
        {
          path: "/asset/list",
          name: "asset_list",
          title: "资产列表",
          component: () => import("@/views/asset/list/index"),
        },
   
        {
          path: "/asset/operates",
          name: "operates",
          title: "操作记录",
          component: () => import("@/views/asset/operates/index"),
        },
        {
          path: "/asset/change",
          name: "asset_change",
          title: "资产变更",
          component: () => import("@/views/asset/change/index"),
        },
        {
          path: "/asset/dispose",
          name: "asset_dispose",
          title: "处置管理",
          component: () => import("@/views/asset/dispose/index"),
        },
        {
          path: "/asset/allot",
          name: "asset_allot",
          title: "调拨管理",
          component: () => import("@/views/asset/allot/index"),
        },
        {
          path: "/asset/maintain",
          name: "asset_maintain",
          title: "维修管理",
          component: () => import("@/views/asset/maintain/index"),
        },
        {
          path: "/asset/borrow",
          name: "asset_borrow",
          title: "借用|归还",
          component: () => import("@/views/asset/borrow/index"),
        },
        {
          path: "/asset/receive",
          name: "asset_receive",
          title: "领用|退还",
          component: () => import("@/views/asset/receive/index"),
        },
        {
          path: "/asset/examine",
          name: "asset_examine",
          title: "审批管理",
          component: () => import("@/views/asset/examine/index"),
        },
        {
          path: "/asset/epc",
          name: "asset_epc",
          title: "EPC绑定",
          component: () => import("@/views/asset/epcBind/index"),
        },

        /* 资产管理 end */

        /* 盘点管理 start */
        {
          path: "/pd/taskexamine",
          name: "pd_task_examine",
          title: "执行审批",
          component: () => import("@/views/pd/check/examine"),
        },
        {
          path: "/pd/task",
          name: "pd_task",
          title: "盘点审批",
          component: () => import("@/views/pd/task/index"),
        },

        {
          path: "/pd/check",
          name: "pd_check",
          title: "盘点审批",
          component: () => import("@/views/pd/check/index"),
        },
        {
          path: "/pd/gainorloss",
          name: "",
          title: "损益处理",
          component: () => import("@/views/pd/task/gainorloss"),
        },
        {
          path: "/ent/list",
          name: "",
          title: "企业列表",
          component: () => import("@/views/ent/list/index"),
        },

        {
          path: "/ent/listAdd",
          name: "edt_list_add",
          title: "",
          component: () => import("@/views/ent/list/add"),
        },
        {
          path: "/ent/package",
          name: "",
          title: "安装包管理",
          component: () => import("@/views/ent/package/index"),
        },

        /* 盘点管理 end */

        /* 全局弹出框 start*/

        {
          path: "",
          name: "asset_epc_bind",
          title: "",
          component: () => import("@/views/asset/epcBind/bind"),
        },

        {
          path: "",
          name: "page_export",
          title: "资产信息_导出",
          component: () => import("@/views/finance/page/export"),
        },
        {
          path: "",
          name: "page_details",
          title: "资产信息_折旧详情",
          component: () => import("@/views/finance/page/details"),
        },
        {
          path: "",
          name: "ent_package_add",
          title: "安装包管理添加",
          component: () => import("@/views/ent/package/add"),
        },
        {
          path: "",
          name: "file_upload",
          title: "文件上传",
          component: () => import("@/views/file/upload"),
        },
        {
          path: "",
          name: "add_selece_asset",
          title: "资产选择--公共",
          component: () => import("@/views/asset/add_selece_asset/index"),
        },
        {
          path: "/pd/examine",
          name: "pd_examine",
          title: "审批管理",
          component: () => import("@/views/pd/check/examine"),
        },
        {
          path: "/pd/little",
          name: "pd_gainorloss_little",
          title: "损益处理",
          component: () => import("@/views/pd/task/little"),
        },
        {
          path: "/pd/little",
          name: "pd_gainorloss_edit",
          title: "新增入库",
          component: () => import("@/views/pd/task/edit"),
        },
        {
          path: "",
          name: "asset_list_operationRecord",
          title: "资产列表-操作记录",
          component: () => import("@/views/asset/list/operationRecord"),
        },
        {
          path: "",
          name: "asset_list_printTemp",
          title: "打印模板选择",
          component: () => import("@/views/asset/list/print_temp"),
        },
        {
          path: "",
          name: "asset_list_select",
          title: "资产列表-选择资产列表",
          component: () => import("@/views/asset/list/select"),
        },
        {
          path: "",
          name: "pd_task_add",
          title: "盘点任务-添加",
          component: () => import("@/views/pd/task/add"),
        },
        {
          path: "",
          name: "pd_task_details",
          title: "盘点任务-添加",
          component: () => import("@/views/pd/task/details"),
        },
        {
          path: "",
          name: "asset_receive_receiveEdit",
          title: "资产领用-编辑",
          component: () => import("@/views/asset/receive/receive_edit"),
        },
        {
          path: "",
          name: "asset_receive_receiveAdd",
          title: "资产领用-新增",
          component: () => import("@/views/asset/receive/receive_add"),
        },
        {
          path: "",
          name: "asset_receive_returnEdit",
          title: "资产退还-编辑",
          component: () => import("@/views/asset/receive/return_edit"),
        },
        {
          path: "",
          name: "asset_receive_returnAdd",
          title: "资产退还-新增",
          component: () => import("@/views/asset/receive/return_add"),
        },

        {
          path: "",
          name: "asset_borrow_borrowEdit",
          title: "资产借用-编辑",
          component: () => import("@/views/asset/borrow/borrow_edit"),
        },
        {
          path: "",
          name: "asset_borrow_borrowAdd",
          title: "资产借用-新增",
          component: () => import("@/views/asset/borrow/borrow_add"),
        },
        {
          path: "",
          name: "asset_borrow_returnEdit",
          title: "资产归还-编辑",
          component: () => import("@/views/asset/borrow/return_edit"),
        },
        {
          path: "",
          name: "asset_borrow_returnAdd",
          title: "资产归还-新增",
          component: () => import("@/views/asset/borrow/return_add"),
        },
        {
          path: "",
          name: "asset_maintain_edit",
          title: "资产维修-编辑",
          component: () => import("@/views/asset/maintain/edit"),
        },
        {
          path: "",
          name: "asset_maintain_add",
          title: "资产维修-新增",
          component: () => import("@/views/asset/maintain/add"),
        },

        {
          path: "",
          name: "asset_allot_edit",
          title: "资产调拨-编辑",
          component: () => import("@/views/asset/allot/edit"),
        },
        {
          path: "",
          name: "asset_allot_add",
          title: "资产调拨-新增",
          component: () => import("@/views/asset/allot/add"),
        },

        {
          path: "",
          name: "asset_dispose_edit",
          title: "资产处置-编辑",
          component: () => import("@/views/asset/dispose/edit"),
        },
        {
          path: "",
          name: "asset_dispose_add",
          title: "资产处置-新增",
          component: () => import("@/views/asset/dispose/add"),
        },
        {
          path: "",
          name: "asset_change_edit",
          title: "资产变更-编辑",
          component: () => import("@/views/asset/change/edit"),
        },
        {
          path: "",
          name: "asset_change_add",
          title: "资产变更-添加",
          component: () => import("@/views/asset/change/add"),
        },
        {
          path: "",
          name: "asset_list_upload",
          title: "资产列表-上传",
          component: () => import("@/views/asset/list/upload"),
        },
        {
          path: "",
          name: "asset_list_return",
          title: "资产列表-换绑",
          component: () => import("@/views/asset/list/return"),
        },
        {
          path: "",
          name: "asset_list_export",
          title: "资产列表-导出",
          component: () => import("@/views/asset/list/export"),
        },
        {
          path: "",
          name: "asset_list_repair",
          title: "资产列表-维修",
          component: () => import("@/views/asset/list/repair.vue"),
        },
        {
          path: "",
          name: "asset_list_Intie",
          title: "资产列表-换绑",
          component: () => import("@/views/asset/list/Intie"),
        },
        {
          path: "",
          name: "asset_list_change",
          title: "资产列表-变更",
          component: () => import("@/views/asset/list/change"),
        },
        {
          path: "",
          name: "asset_list_edit",
          title: "资产列表-编辑",
          component: () => import("@/views/asset/list/edit"),
        },
        {
          path: "",
          name: "asset_list_global_details",
          title: "资产列表-全局详情",
          component: () => import("@/views/asset/list/global_details"),
        },

        {
          path: "",
          name: "asset_list_erepair",
          title: "资产列表_维修完成",
          component: () => import("@/views/asset/list/erepair"),
        },
        {
          path: "",
          name: "asset_epc_search",
          title: "资产录入_EPC扫描",
          component: () => import("@/views/asset/add/epc"),
        },
        {
          path: "",
          name: "sys_add_dept",
          title: "组织架构-添加组织",
          component: () => import("@/views/sys/dept/add_dept"),
        },
        {
          path: "",
          name: "sys_epc_bind",
          title: "组织架构-添加组织",
          component: () => import("@/views/sys/dept/epc_bind"),
        },
        {
          path: "",
          name: "sys_add_account",
          title: "组织架构--添加用户",
          component: () => import("@/views/sys/dept/add_account"),
        },

        {
          path: "",
          name: "sys_add_role",
          title: "权限设置--新增角色",
          component: () => import("@/views/sys/permission/add_role"),
        },
        {
          path: "",
          name: "sys_add_area",
          title: "区域管理--新增区域",
          component: () => import("@/views/sys/area/add_area"),
        },
        {
          path: "",
          name: "sys_add_classify",
          title: "资产分类--新增资产",
          component: () => import("@/views/sys/classify/add_classify"),
        },

        {
          path: "",
          name: "sys_add_dictionaries",
          title: "字典管理--新增字典",
          component: () => import("@/views/sys/dictionaries/add_dictionaries"),
        },
        {
          path: "",
          name: "select_account",
          title: "权限设置--选择用户",
          component: () => import("@/views/sys/dept/select_account"),
        },
        {
          path: "",
          name: "sys_add_temp",
          title: "资产模板--新增模板",
          component: () => import("@/views/sys/template/add_temp"),
        },
        {
          path: "",
          name: "sys_add_form",
          title: "资产模板--新增自定义",
          component: () => import("@/views/sys/template/add_form"),
        },
        {
          path: "",
          name: "passwordedit",

          component: () => import("@/views/login/edit"),
        },
        {
          path: "",
          name: "login-setting",

          component: () => import("@/views/login/setting"),
        },
        /* 全局弹出框 end*/
      ],
    },
    { path: "/", redirect: "/home" },
    {
      path: "/login",
      name: "login",

      component: () => import("@/views/login/index"),
    },
    {
      path: "dialog",
      name: `component-dialog`,
      component: () => import("@/components/dialog/dialog"),
    },
    {
      path: "*",
      name: "404",
      component: error404,
    },
  ],
});
// 路由守卫
router.beforeEach((to, form, next) => {

  NProgress.start();

  if (to.path == "/login") {
    window.sessionStorage.clear();

    return next();
  }

  const token = window.sessionStorage.getItem("ZCTOKEN");
  if (!token) {
    window.sessionStorage.clear();
    return next("/login");
  }
  store.commit(
    "current_path",
    routerFuleter(router.options.routes[0].children, to.path)
  );
  window.sessionStorage.setItem(
    "current_path",
    JSON.stringify(routerFuleter(router.options.routes[0].children, to.path))
  );
  next();
});
router.afterEach(() => {
  // 进度条
  
  NProgress.done();
  store.commit("WEBSOCKET_RFIDOFF");
  // 多页控制 打开新的页面
  // 更改标题
});
export default router;
